export default __webpack_public_path__ + "static/media/Flag_of_Indonesia.deb61040.svg";